export const room = {
    floor: 'floor ',
    ceiling: 'ceiling' ,
    wallBack: 'wall_front',
    wallFront: 'wall_back',
    wallRights: 'wall_left',
    wallLeft: 'wall_rights',
    wallTransparence: 'wall_transparence',
    spot: 'Spot',
    // spot2: 'Spot.001',
} as const;

export const xShift = 0.5;
export const yShift = 0.01;
export const zShift = 0.5;

export const backWallOffset = 0.99;

export const pointLight = {
    color: 0xffffff,
    intensity: 2,
    castShadow: false,
    enabled: false,
    topOffset: 0.2,
};
